import React, { useContext, useEffect, useState } from 'react'
import {Container, Form, Table} from 'react-bootstrap'
import { CSVLink } from "react-csv";
import { getError } from "../../Utils/GetErrors";
import axios from 'axios';
import { Store } from '../../Store';
import ToastIt from "../../components/Toast";

const UserData = () => {
     const { state } = useContext(Store);
     const { userInfo, baseUrl } = state;
   const [searchQuery, setSearchQuery] = useState("");
  const [Users, setUsers] = useState([]);
  const [totalFunds, setTotalFunds] = useState(0);
  const [csvData, setCsvData] = useState([]);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [variance, setVariance] = useState("");

  //Fetch user data from BE
  useEffect(() => {
    async function fetchUsers() {
      try {
        const { data } = await axios.get(`${baseUrl}/user/account-balances`, {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        });
        const total = data.reduce((sum, user) => sum + (user.balance || 0), 0);
        setTotalFunds(total);
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }
    fetchUsers();
  }, [userInfo, baseUrl]);

   const handleSearchChange = (e) => {
      setSearchQuery(e.target.value);
    };
    const filteredUsers = Users.filter((user) =>
      Object.values(user).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
      // console.log('users',Users)
    
      const handleUserLevelChange = async (userId, userLevel) => {
        try {
          const { data } = await axios.put(
            `${baseUrl}/user/${userId}/level`,
            { userLevel },
            {
              headers: { Authorization: `Bearer ${userInfo.token}` },
            }
          );
          setUsers(Users.map((user) => (user._id === userId ? data.user : user)));
          setToastMessage("User level updated successfully");
          setVariance("success");
          setShowToast(true);
        } catch (error) {
          setToastMessage(getError(error));
          setVariance("danger");
          setShowToast(true);
        }
      };
    
      const handleUserStatusChange = async (userId, status) => {
        try {
          const { data } = await axios.put(
            `${baseUrl}/user/${userId}/status`,
            { status },
            {
              headers: { Authorization: `Bearer ${userInfo.token}` },
            }
          );
          setUsers(Users.map((user) => (user._id === userId ? data.user : user)));
    
          setToastMessage("User status updated successfully");
          setVariance("success");
          setShowToast(true);
        } catch (error) {
          setToastMessage(getError(error));
          setVariance("danger");
          setShowToast(true);
        }
      };

  // CSV DATA
  useEffect(() => {
    const csvData = [
       ...Users.map((user) => ({
        Statistic: "Users",
        Username: user.username,
        Email: user.email,
        Phone: user.phone,
        Level: user.isAdmin ? "Admin" : "User",
        TotalPurchase: totalFunds,
        WalletBalance: user.balance,
      })),
    ];
    setCsvData(csvData);
  }, [Users, totalFunds]);


  return (
   <>
    <Container className="mt-3 py-1">
      <h3 className='text-center text-primary'>MANAGE USERS</h3>
      <hr />
        <Form.Group
          controlId="searchUsers"
          className="mb-2"
          style={{ maxWidth: "300px", right: "5px" }}
        >
          <Form.Control
            type="text"
            placeholder="Search Users"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </Form.Group>
        <div className="table-responsive">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Username</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Level</th>
                {/* <th>Tt Purchase</th> */}
                <th>Wallet</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((user, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{user.username}</td>
                  <td>{user.phone}</td>
                  <td>{user.email}</td>
                  <td>
                    <Form.Select
                      value={user.userLevel}
                      onChange={(e) =>
                        handleUserLevelChange(user._id, e.target.value)
                      }
                    >
                      <option value="Customer">Customer</option>
                      <option value="Agent">Agent</option>
                      <option value="Super Agent">Super Agent</option>
                      <option value="Admin">Admin</option>
                    </Form.Select>
                  </td>
                  {/* <td>{totalFunds?.toFixed(2)}</td> */}
                  <td>{user.balance?.toFixed(2)}</td>
                  <td>
                    <Form.Select
                      value={user.status}
                      style={{
                        backgroundColor:
                          user.status === "Banned" ? "red" : "green",
                        color: "white",
                      }}
                      onChange={(e) =>
                        handleUserStatusChange(user._id, e.target.value)
                      }
                    >
                      <option value="Active">Active</option>
                      <option value="Banned">Banned</option>
                    </Form.Select>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      <CSVLink
        className="btn btn-primary p-2 my-5 text-center w-100"
        data={csvData}
        filename={"GhanaBundles-admin-stats.csv"}
      >
        Export to Excel
      </CSVLink>
      </Container>
      <ToastIt
        Variance={variance}
        Message={toastMessage}
        ShowToast={showToast}
        OnClose={() => setShowToast(false)}
      />
      </>
  )
}

export default UserData